export const SEARCH_FORM_SUBMIT = 'STAFF.ONLINE_SURVEYS.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'STAFF.ONLINE_SURVEYS.SORT_CHANGE';
export const PAGE_CHANGE = 'STAFF.ONLINE_SURVEYS.PAGE_CHANGE';
export const FETCH_LIST = 'STAFF.ONLINE_SURVEYS.FETCH_LIST';
export const FETCH_ONE = 'STAFF.ONLINE_SURVEY.FETCH_ONE';
export const CLEAR_ONE = 'STAFF.ONLINE_SURVEY.CLEAR_ONE';
